import withRouter from "Components/Common/withRouter";
import RocksFields from "Components/organisms/forms/rocks-form/types";
import { FormikHelpers, useFormik } from "formik";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { HumanResourcesSliceState } from "slices/human-resources/reducer";
import { RocksSliceState } from "slices/business-development/rocks/reducer";
import { getRocksSearchFields, submitRocksForm } from "slices/business-development/rocks/thunk";
import { getManagers } from "slices/human-resources/thunk";
import RocksFormTemplate from "../../../../Components/templates/business-development/rocks/rocks-form";
import { QUARTERS, RocksFormValidation, YEARS } from "data/rocks-form";



const selectRocks = createSelector(
    (state: any) => state.Rocks,
    ({ rocksStatus }: RocksSliceState) => ({
        rocksStatus
    })
)

const selectHumanResources = createSelector(
    (state: any) => state.HumanResources,
    ({ managers }: HumanResourcesSliceState) => ({
        managers
    })
)


const CreateRocksPage = (props: any) => {
    document.title = "Create Rock | IbexIQ";

    const dispatch: any = useDispatch();
    const {
        managers
    } = useSelector(selectHumanResources);

    const {
        rocksStatus
    } = useSelector(selectRocks);

    useEffect(() => {
        if (rocksStatus.length === 0 || managers.length === 0) {
            dispatch(getManagers())
            dispatch(getRocksSearchFields())
        }
    }, [])

    const handleSubmitRocksForm = async (vals: RocksFields, helpers: FormikHelpers<RocksFields>) => {
        helpers.setSubmitting(true);
        const res = await dispatch(submitRocksForm(vals, () => helpers.resetForm({})))

        if (res)
            handleBack();
        helpers.setSubmitting(false);
    }

    const initialValues: RocksFields = useMemo(() => ({
        accountableID: "",
        statusId: "",
        quarter: "",
        year: "",
        helpFrom: "",
        completedAt: "",
        description: "",
        rocks: "",
    }), [])

    const { values, errors, touched, handleSubmit, handleBlur, handleChange, isValid, isSubmitting } = useFormik({
        onSubmit: handleSubmitRocksForm,
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: RocksFormValidation
    })

    const handleBack = () => {
        props.router.navigate(-1);
    }

    return <RocksFormTemplate
        values={values}
        years={[...YEARS.map(y => ({ label: String(y), value: String(y) }))]}
        quarters={[...QUARTERS.map(q => ({ label: q, value: q }))]}
        employees={[...managers.map(e => ({ label: `${e.commonName ?? e.firstName} ${e.lastName}`, value: e.id }))]}
        breadcrumbItem={"Create Rock"}
        title={"Create Rock"}
        subtitle={"Please fill out the following fields and click submit."}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
        handleBlur={handleBlur}
        handleSubmit={handleSubmit}
        handleCancel={handleBack}
        isValid={isValid}
        isSubmitting={isSubmitting}
    />

}

export default withRouter(CreateRocksPage);